<template>

  <div class="w_inner">
    <div class="MnewsMain">
    <div class="con_box inner_banner news wow fadeIn animated" data-wow-delay="0.0s">
      <!-- <div class="text_conShow w">
                  <div class="text_box">
                    <div class="title wow fadeInUp animated"  data-wow-delay="0.2s">{{dto.title}}</div>
                    <div class="con wow fadeInUp animated" data-wow-delay="0.4s"  v-html="utils.ShowContentBr(dto.content)">
                    </div>
                  </div>
              </div> -->
    </div>
    <div class="innerWrap">
      <div class="main_container">
        <div class="title wow fadeInUp animated" data-wow-delay=".4s">{{ $t('news.title') }}</div>
        <div class="news_list">
          <template v-if="total == 0">
            <div class="nodataTips">{{ $t('news.tip') }}~</div>
          </template>
          <div class="list">
            <ul>
              <template v-for="(item, index) in news_list">
              <li class="clearfix" :key="index">
                <router-link :to="{ name: 'newsdetail', params: { id: item.id } }">
                  <img :src="item.imgUrl" alt="">
                  <div class="desc">
                    <div class="tishow">{{ item.title }}</div>
                    <div class="con">
                      {{ item.zhaiyao }}
                    </div>
                    <div class="pull">
                      <span class="read">{{ item.click }}</span>
                      <span class="time">{{ item.publishTime }}</span>
                    </div>
                    <div class="more"><span>{{ $t('news.view') }}</span></div>
                  </div>
                </router-link>
              </li>
              </template>
            </ul>
          </div>
          
        </div>
      </div>
    </div>
    </div>
  </div>

</template>

<script>
import WOW from "../../../node_modules/wowjs/dist/wow";
export default {
  data() {
    return {
      total: 0,
      pagesize: 8,
      pageindex:0,
      isend:false,
      loading:false,
      scroll_fun:null,
      news_list: []
    }
  },
   components: {

  },
  
  created() {
     this.scroll_fun = this.utils.AddLoadMoreListener(this.GetList,0);

  },
  mounted() {
    //滚动页面加载动画
    let wow = new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
    document.documentElement.scrollTop = 0;
     this.GetList();
  },

 

  methods: {


    Initwow() {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();
    },
    GetList() {
        if (this.isend||this.loading) return;
       this.pageindex++;
       this.loading=true;
      var url = "/pageapi/News/GetList";
      this.$http.post(url, { pageindex: this.pageindex, pagesize: this.pagesize }).then(function (res) {
        this.loading=false;
        if (res.data.status == 1) {
          this.news_list = this.news_list.concat(res.data.ds);
          this.total = res.data.total;
        
          if(this.pageindex*this.pagesize >=this.total){
                      this.isend=true;
          }
        }
      }.bind(this)).catch(function () {
      });
    },
    PropsChange(){
            this.list=[];
            this.isend=false;
            if (this.pageindex!==0) this.pageindex=0;
            else this.GetList();
        },
  },
  watch: {
    $route(newVal, oldVal) {
      this.id = this.$route.params.id;
      this.GetCat();
      this.GetProList();
    },
    pageindex: function () {
      this.GetList();
    },
  },
   destroyed(){
        window.removeEventListener("scroll",this.scroll_fun);
    }
};
</script>
